import React, { useState } from "react";
import CustomButton from "../components/Button/CustomButton";
import toast from "react-hot-toast";
import apiClient from "../services/apiClient";

const ContactUs = () => {
  // State for form inputs
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  // Handle input changes
  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.id]: event.target.value });
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      alert("Please fill all fields");
      return;
    }

    setLoading(true);
    try {
      const response = await apiClient.post("/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      toast.success("sent!");
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Failed to send message.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section class="contact" id="contact">
        <div class="container">
          <div class="heading text-center">
            <h2>Connect with Us Today</h2>
            <p>
              We're here to answer your questions and provide the support you need. <br />
              Reach out to us through any of the contact methods below, and we'll get back to you as
              soon as possible.
            </p>
          </div>

          <form class="row g-3 my-4" onSubmit={handleSubmit}>
            <div class="col-md-6">
              <label for="name" class="form-label">
                Name
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div class="col-md-6">
              <label for="email" class="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div class="col-12">
              <label for="message" class="form-label">
                Message
              </label>
              <textarea
                className="form-control"
                id="message"
                rows="4"
                placeholder="Write your message here..."
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <div class="col-12 text-center">
              <CustomButton onClick={() => {}} type="submit" loading={loading}>
                Submit
              </CustomButton>
            </div>
          </form>

          <div class="row justify-content-center">
            <div class="col-12"></div>
            <div class="col-12 col-lg-10 mb-sm-5 mb-md-0 py-4 py-lg-5 contactDetail">
              <div class="title text-center">
                <h3>Contact Detail</h3>
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-auto">
                  <div class="content">
                    <div class="info">
                      <i class="fas fa-mobile-alt"></i>
                      <h4 class="d-inline-block">
                        PHONE :<br />
                        <span class="d-none d-md-block">1-732-354-1541</span>
                        <span class="d-block d-md-none">
                          <a href="tel:+7323541541">1-732-354-1541</a>
                        </span>
                      </h4>
                    </div>
                  </div>
                </div>
                <div class="col-lg-auto px-lg-5">
                  <div class="content">
                    <div class="info">
                      <i class="far fa-envelope"></i>
                      <h4 class="d-inline-block">
                        EMAIL :<br />
                        <span>
                          <a href="mailto:info@dialgrid.ai">info@dialgrid.ai</a>
                        </span>
                      </h4>
                    </div>
                  </div>
                </div>
                <div class="col-lg-auto">
                  <div class="content">
                    <div class="info">
                      <i class="fas fa-map-marker-alt"></i>
                      <h4 class="d-inline-block">
                        ADDRESS :<br />
                        <span>3840 Park Avenue, STE C-205, Edison, NJ 08820</span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
